export const AddEnvToImgRef = (imgArr) => {
    return imgArr.map((img) => {
        return `${process.env.REACT_APP_POS_URL}/${img}`
    })
}